import type { DataOptions } from './types';
import { error } from '@/util/console';

const navigator = window?.navigator;
const navigatorEnable = navigator && navigator.userAgent.indexOf('Chrome') !== -1;
const functionEnable = typeof navigator.sendBeacon === 'function';

/**
 *
 * @param url 发送地址
 * @param data 发送内容
 * @param forceSendBeacon 是否强制使用 sendBeacon 方式发送埋点。
 */
export default function send({ url, data, forceSendBeacon }: DataOptions) {
    if (!navigatorEnable && !forceSendBeacon || !functionEnable) return false;
    // xhook 如果改写了 FormData
    if (typeof data === 'object' && data.fd) {
        data = data.fd;
    }
    try {
        return navigator.sendBeacon(url, data);
    } catch (err) {
        error('[error 403]', 'navigator.sendBeacon 报错', err);
        return false;
    }
}
